module.exports = __webpack_public_path__ + "img/5.bbb5ec0c.png";